import type { LightGalleryCoreSettings } from 'lightgallery/lg-settings';
import type { GalleryItem as LightGalleryItem } from 'lightgallery/lg-utils';
import type {
  MediaSourceSize,
  MediaViewerSlideTransition,
} from '../media-viewer.types';

export interface LightGalleryConfig {
  readonly licenseKey: string;
}

/** Shows `src` (the tile) first, then swaps to `previewSrc` once it has loaded. */
export interface ViewerSlideItem extends LightGalleryItem {
  /** The item's `id`, identifying the slide across updates. */
  readonly id?: string;
  /** The preview, when `src` is only the tile (or a blurhash) standing in for it. */
  readonly previewSrc?: string;
  /** Holds `src` at this size, i.e. the size of the image that will replace it. */
  readonly previewSize?: MediaSourceSize;
  /** Shows a spinner over the slide until the item is replaced. */
  readonly loading?: boolean;
  /** Shows the "Failed to load content" message instead of the slide. */
  readonly loadFailed?: boolean;
}

export const lightGalleryTransitionMap: {
  [key in MediaViewerSlideTransition]: LightGalleryCoreSettings['mode'];
} = {
  slide: 'lg-slide',
  'slide-vertical': 'lg-slide-vertical',
  fade: 'lg-fade',
  'zoom-in': 'lg-zoom-in',
  'zoom-out': 'lg-zoom-out',
};

export const lightGalleryThumbnailProperty = 'data-lg-thumb-image';

export const lightGalleryItemSelector = 'fl-media-viewer-item';

export interface LightGalleryVideoSource {
  source: { src: string; type?: string }[];
  attributes: {
    preload: boolean;
    controls: boolean;
  };
}
